import {Controller} from "stimulus"
import $ from 'jquery';
import popper from '@popperjs/core'
import bootbox from 'bootbox/bootbox';
import toast from "bootstrap/js/src/toast";
import {setSessionVar, checkSessionVar} from './sessionStorage_controller'
import consumer from "../channels/consumer"


//METODOS
String.prototype.isEmpty = function () {
    return (this.length === 0 || !this.trim());
}

function open_room() {
    let user_id = $('#user_id');
    let room_id = $('#room_id');
    let room_message_room_id = $('#room_message_room_id');
    let room_message_reciever_id = $('#room_message_reciever_id');
    let room_messages = $('#message');
    let btn_room_send_message = $('#btn_send_message');
    let footer_action_assistant = $('.footer-asistant-line');
    let message_container = $('#message_container');

    $.ajax({
        url: location.origin + `/${sessionStorage.getItem('locale')}/assistant_online`,
        data: {},
        type: 'GET',
        beforeSend: function () {
            message_container.html(`
                      <div class="assistant-online-loader" >
                        <span class="fa fa-circle-o-notch fa-spin fa-3x"></span>
                      </div>
                    `)
        },
        success: function (data) {
            let html = '';
            if (data.success) {
                footer_action_assistant[0].classList.remove('ocultar');
                room_id[0].setAttribute('data-room-id', data.data.room.id);
                user_id[0].setAttribute('data-user-id', data.data.user.id);
                user_id[0].setAttribute('data-commercial', data.data.user.is_commercial);
                user_id[0].setAttribute('data-commercial-id', data.data.room.commercial_id);
                room_message_room_id.val(data.data.room.id);
                room_message_reciever_id.val(data.data.reciever.id);

                setSessionVar('chat_room', data.data.room.id, 'add', false).then(
                    room => {
                        setSessionVar('reciever_id', data.data.reciever.id, 'add', false).then(
                            reciever => {
                                setSessionVar('user_id', data.data.user.id, 'add', false).then();
                                setSessionVar('is_commercial', data.data.is_commercial, 'add', false).then();
                            }
                        )
                    }
                );

                let count_messsage = 0;
                data.data.messages.map((elem, index) => {
                    count_messsage += 1;
                    html += tpl_message(elem, data.data.user);
                })

                if (count_messsage > 0) {
                    message_container.html(html);
                    message_container[0].scrollTo(0, message_container[0].scrollHeight);
                } else {
                    message_container.html(`<div class='block-message initial-message mb-3'>
                  <div class='message text-center'>
                    Bienvenido a la asistencia en linea<br>
                    ¿Cómo podemos ayudarle?
                  </div>
                </div>`);
                    message_container[0].scrollTo(0, message_container[0].scrollHeight);
                }

                connect_cable(data.data.room.id);
            } else {
                message_container.html(`
                <div>
                    <div class="assistant-online-loader d-flex flex-column align-items-center justify-content-center">
                        <span class="text-center">${data.msg}</span>
<!--                            <button class="btn-outline btn" data-action="assistantOnline#refresh">-->
<!--                                <span class="fa fa-refresh fa-3x" ></span>-->
<!--                            </button>-->
                    </div>
                    <div>
                        <div class="container d-flex flex-column">
                            <form id="contactForm" method="POST" enctype="multipart/form-data" action="${location.origin}/${sessionStorage.getItem('locale')}/admin/users/send_email" data-assistantOnline-target="form">
                                <div class="form-group">
                                    <label for="nombre">Nombre:</label>
                                    <input type="text" id="nombre" name="nombre" required placeholder="Tu nombre completo">
                                        <span class="error-message"></span>
                                </div>
                                <div class="form-group">
                                    <label for="email">Correo electrónico:</label>
                                        <input type="email" id="email" name="email" required placeholder="tu@email.com">
                                        <span class="error-message"></span>
                                </div>
                                <div class="form-group d-flex flex-column">
                                    <label for="mensaje">Mensaje:</label>
                                    <textarea style="border: 1px solid #bbb; border-radius: 3px; margin: 0; padding: 0.4em 0.6em; min-height: 5em; outline: none;" id="mensaje" name="mensaje" required placeholder="Escribe tu mensaje aquí..."></textarea>
                                    <span class="error-message"></span>
                                </div>
                                <button class="btn btn-primary" type="submit" data-action="click->assistantOnline#email" >Enviar mensaje</button>
                            </form>
                        </div>
                    </div>
                </div>
                `)

                footer_action_assistant[0].classList.add('ocultar');
            }
        }
    })
}

function tpl_message(message, current_user) {
    let my_message = ''
    let theirs_message = ''

    if (current_user.id === message.user.id) {
        my_message = 'my-message';
    } else {
        theirs_message = 'theirs-message';
    }

    return `
         <div id="${message.id}" class="block-message ${my_message} mb-3">
              <div class="message ${theirs_message}"  data-from="${message.user_id}" data-to="${message.reciever_id}" style="word-break: break-all;">
                ${message.message}
              </div>
              <div class="info-message">
                ${message.user.username}
                ${message.created_at}
              </div>
            </div>
        `
}

function connect_cable(room_id) {

    let timeout;
    let user_id = $('#user_id');
    let room = $('#room_id');
    let room_ident = room_id || room[0].dataset.roomId
    let room_messages = $('#message');
    let room_message_reciever_id = $('#room_message_reciever_id');
    let btn_room_send_message = document.getElementById('btn_send_message');
    let footer_action_assistant = $('.footer-asistant-line');
    let message_container = $('#message_container');
    let assistant = $('#assistant-line');
    let close_assistant = $('#close-assistant-line');
    let close_assistant_online2 = $('#close-assistant-line2')

    const channel_room = consumer.subscriptions.create({channel: "RoomChannel", room_id: room_ident}, {
        connected() {

            sendMessage({
                type: 'connecting',
                message: 'Conectando',
                status: true
            });

            close_assistant.css('opacity', '1');
            close_assistant.css('visibility', 'visible');
            close_assistant_online2.css('opacity', '0');

            const ignoredKeys = ["Enter", "Alt", "Shift", "Backspace", "Control", "Meta", "Tab", "CapsLock"];

            room_messages.on('keyup', function (e) {
                if (e.key === "Enter") {
                    if (room_messages.val().trim() !== "") {
                        btn_room_send_message.click();
                    } else {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }

                if (!ignoredKeys.includes(e.key)) {
                    sendMessage({
                        type: 'typing',
                        message: 'Escribiendo',
                        code: e.key
                    })
                }
            });

            btn_room_send_message.addEventListener('click', (e) => {
                const message = room_messages.val().trim();
                if (room_messages.val().trim() === '') {
                    e.stopPropagation();
                    e.preventDefault();
                }

            });

            ///////////////////////
            close_assistant.on('click', function () {
                channel_room.send({
                    type: 'connecting',
                    room_id: Number(room_ident),
                    from: Number(user_id[0].dataset.userId),
                    to: Number(room_message_reciever_id[0].value),
                    status: false
                })
                assistant.removeClass('active');
                assistant.removeClass('minimized');
                setSessionVar('chat_room', '', 'delete', false).then(
                    room => {
                        consumer.subscriptions.remove(channel_room);
                        consumer.disconnect();
                        setSessionVar('reciever_id', '', 'delete', false).then(
                            reciever => {
                                setSessionVar('user_id', '', 'delete', false).then();
                                setSessionVar('is_commercial', '', 'delete', false).then();
                            }
                        )
                    }
                );
            })

            //////////////////////
            function sendMessage(data) {
                channel_room.send({
                    ...data,
                    room_id: Number(room_ident),
                    from: Number(user_id[0].dataset.userId),
                    to: Number(room_message_reciever_id[0].value),
                });
            }
        },

        disconnected() {
            consumer.subscriptions.remove(channel_room);
            if (sessionStorage.getItem('is_commercial') === 'false') {
                let active = active_comercial(sessionStorage.getItem('reciever_id'))
            }

        },

        received(data) {
            switch (data['type']) {
                case "typing":
                    if (parseInt(user_id[0].dataset.userId) === parseInt(data['to'])) {
                        if (data['code'] === "Enter" || data['code'] === "Alt" || data['code'] === "Shift" || data['code'] === "Backspace") {
                            chat_status.style.bottom = '0';
                        } else {
                            chat_status.style.bottom = '60px';
                        }
                        clearTimeout(timeout);
                        timeout = setTimeout(function () {
                            chat_status.style.bottom = '0';
                        }, 1000);
                    }

                    break;
                case "request_info":
                    channel_room.send({
                        type: 'info',
                        room_id: Number(room_ident),
                        from: Number(user_id[0].dataset.userId),
                        to: Number(room_message_reciever_id[0].value),
                    })
                    break;
                case "terminate":
                    if (parseInt(user_id[0].dataset.userId) === parseInt(data['to'])) {
                        message_container.append(data['message']);
                        message_container[0].scrollTo(0, message_container[0].scrollHeight);

                        setTimeout(function () {
                            channel_room.send({
                                type: 'connecting',
                                message: 'Desconectando',
                                status: false,
                                room_id: Number(room_ident),
                                from: Number(user_id[0].dataset.userId),
                                to: Number(room_message_reciever_id[0].value),
                            })
                            close_assistant.trigger('click');
                        }, 2000)
                    }

                    break;
                case "message":
                    message_container.val('');

                    if (parseInt(user_id[0].dataset.userId) === parseInt(data['message'].user_id) || parseInt(user_id[0].dataset.userId) === parseInt(data['message'].reciever_id)) {
                        let html = (parseInt(user_id[0].dataset.userId) === parseInt(data['message'].user_id)) ? data['mine'] : data['theirs'];

                        message_container.append(html);
                        message_container[0].scrollTo(0, message_container[0].scrollHeight);
                    }

                    break;
                default:
                    console.log("")
            }
        }
    })
    ///////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////////////////////////////////////////////////////////////////
    // const channel_room = consumer.subscriptions.create({channel: "RoomChannel", room_id: room_id}, {
    //     connected() {
    //         console.log("Conectado a Action Cable");
    //         channel_room.send({
    //             type: 'connecting',
    //             room_id: Number(room_id),
    //             from: Number(user_id[0].dataset.userId),
    //             to: Number(room_message_reciever_id[0].value),
    //             status: true
    //         })
    //
    //         close_assistant.css('opacity', '1');
    //         close_assistant.css('visibility', 'visible');
    //         close_assistant_online2.css('opacity', '0');
    //         //Al presionar cualquier tecla, notificar al otro usuario que se esta ecribiendo un mensaje
    //         room_messages.on('keydown', function (e) {
    //             console.log("Presionando tecla enter");
    //             if (e.key === "Enter") {
    //                 if (!room_messages[0].value.isEmpty()) {
    //                     btn_room_send_message.trigger('click');
    //                 } else {
    //                     e.stopPropagation();
    //                     e.preventDefault();
    //
    //                 }
    //
    //             }
    //
    //             if (e.key !== "Enter" || e.key !== "Alt" || e.key !== "Shift" || e.key !== "Backspace") {
    //                 channel_room.send({
    //                     type: 'typing',
    //                     message: 'Escribiendo',
    //                     room_id: Number(room_id),
    //                     from: Number(user_id[0].dataset.userId),
    //                     to: Number(room_message_reciever_id[0].value),
    //                     code: e.key
    //                 })
    //             }
    //
    //
    //         })
    //
    //         // Called when the subscription is ready for use on the server
    //         close_assistant.on('click', function () {
    //             channel_room.send({
    //                 type: 'connecting',
    //                 room_id: Number(room_id),
    //                 from: Number(user_id[0].dataset.userId),
    //                 to: Number(room_message_reciever_id[0].value),
    //                 status: false
    //             })
    //             assistant.removeClass('active');
    //             assistant.removeClass('minimized');
    //             setSessionVar('chat_room', '', 'delete', false).then(
    //                 room => {
    //                     consumer.disconnect();
    //                     setSessionVar('reciever_id', '', 'delete', false).then(
    //                         reciever => {
    //                             setSessionVar('user_id', '', 'delete', false).then();
    //                             setSessionVar('is_commercial', '', 'delete', false).then();
    //                         }
    //                     )
    //                 }
    //             );
    //         })
    //     },
    //
    //     disconnected() {
    //         console.log("Desconectado del cable")
    //         if (sessionStorage.getItem('is_commercial') === 'false') {
    //             let active = active_comercial(sessionStorage.getItem('reciever_id'))
    //         }
    //
    //     },
    //
    //     received(data) {
    //         // Called when there's incoming data on the websocket for this channel
    //
    //         switch (data.type) {
    //             case 'message':
    //                 //Para que no se mesclen los mensajes de una conversacion con otra
    //                 room_messages[0].value = '';
    //
    //                 if (parseInt(user_id[0].dataset.userId) === parseInt(data.message.user_id) || parseInt(user_id[0].dataset.userId) === parseInt(data.message.reciever_id)) {
    //                     let html;
    //                     if (parseInt(user_id[0].dataset.userId) === parseInt(data.message.user_id)) {
    //                         html = data.mine;
    //                     } else {
    //                         html = data.theirs;
    //                     }
    //
    //                     message_container[0].innerHTML += html
    //                     message_container[0].scrollTo(0, message_container[0].scrollHeight);
    //                 }
    //
    //                 break;
    //             case 'typing':
    //                 if (parseInt(user_id[0].dataset.userId) === parseInt(data.to)) {
    //                     if (data.code === "Enter" && data.code === "Alt" && data.code === "Shift" && data.code === "Backspace") {
    //                         chat_status.style.bottom = '0';
    //                     } else {
    //                         chat_status.style.bottom = '60px';
    //                     }
    //                     clearTimeout(timeout);
    //                     timeout = setTimeout(function () {
    //                         chat_status.style.bottom = '0';
    //                     }, 2000);
    //                 }
    //                 break
    //             case 'request_info':
    //                 if (parseInt(user_id[0].dataset.userId) === parseInt(data.to)) {
    //                     channel_room.send({
    //                         type: 'info',
    //                         room_id: Number(room_id),
    //                         from: Number(user_id[0].dataset.userId),
    //                         to: Number(room_message_reciever_id[0].value)
    //                     })
    //                 }
    //                 break
    //             case 'terminate':
    //                 if (parseInt(user_id[0].dataset.userId) === parseInt(data.to)) {
    //                     message_container[0].innerHTML += data.message
    //                     message_container[0].scrollTo(0, message_container[0].scrollHeight);
    //                     setTimeout(function () {
    //                         close_assistant.trigger('click');
    //                     }, 2000)
    //                 }
    //                 break
    //         }
    //
    //     }
    // });

    /////////
    //FUNC. PARA CREAR O CONECTARSE A UNA SUBC. DE EL CHAT DE ASISTENCIA
    // function createChannelSubscription() {
    //     consumer.subscriptions.subscribe(channel_room);
    // }

    // FUNC. PARA SI NO HAY VISIBILIDAD DESCONECTE CABLE
    // document.addEventListener("visibilitychange", function () {
    //     if (document.visibilityState === "visible") {
    //         createChannelSubscription();
    //     } else {
    //         consumer.subscriptions.remove(channel_room)
    //     }
    // });

}

function active_comercial(id) {
    let result;
    $.ajax({
        url: `${location.origin}/admin/commercial/${id}/active`,
        data: {
            format: 'html'
        },
        type: 'GET',
        success: function (data) {
            result = data;
        }
    });

    return result;
}

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export default class extends Controller {

    static targets = ["form"];

    email(event) {

        event.preventDefault(); // Evita el envío predeterminado del formulario

        let close_assistant_online2 = $('#close-assistant-line2')
        const form = this.formTarget;
        ;
        const formData = new FormData(form);

        const emailInput = form.querySelector('#email');
        let email = emailInput.value.toLowerCase();


        if (!isValidEmail(email)) {
            toastr.error("Por favor, ingresa un correo electrónico válido.");
            return;
        }

        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

        fetch(form.action, {
            method: "POST",
            body: formData,
            headers: {
                "X-Requested-With": "XMLHttpRequest", "X-CSRF-Token": csrfToken // Para identificar solicitudes AJAX
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    toastr.success(data.message);
                    setTimeout(function () {
                        close_assistant_online2.trigger('click');
                    }, 1500);
                } else {
                    toastr.error(data.message);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                alert("Error al enviar el mensaje");
            });


    }

    initialize() {
        // variables
        let assistant = $('#assistant-line');
        let open_assistant = $('#open-asistant-line');
        let minimized_assistant_line = $('#minimized-assistant-line');
        let close_assistant_online = $('#close-assistant-line')
        close_assistant_online.css('opacity', '0');
        close_assistant_online.css('z-index', '0');
        close_assistant_online.css('visibility', 'hidden');
        let close_assistant_online2 = $('#close-assistant-line2')

        open_assistant.on('click', function () {
            assistant.addClass('active');
            open_room();

        })
        minimized_assistant_line.on('click', function () {
            assistant.toggleClass('minimized');
        })

        close_assistant_online2.on('click', function () {
            assistant.removeClass('active');
            assistant.removeClass('minimized');
        })

    }

    connect() {
        // variables
        let user_id = $('#user_id');
        let room_id = $('#room_id');
        let room_message_room_id = $('#room_message_room_id');
        let room_message_reciever_id = $('#room_message_reciever_id');
        let room_messages = $('#message');
        let btn_room_send_message = document.getElementById('btn_send_message');
        let footer_action_assistant = $('.footer-asistant-line');

        btn_room_send_message.addEventListener('click', function () {
            checkSessionVar('chat_room').then(
                chat_room_result => {
                    if (chat_room_result.success) {
                        $.ajax({
                            url: `${location.origin}/room_message/create`,
                            data: {
                                room_message: {
                                    message: room_messages[0].value,
                                    room_id: room_id[0].dataset.roomId,
                                    reciever_id: room_message_reciever_id[0].value
                                }
                            },
                            type: 'POST',
                            success: function (response) {
                                room_messages.val('');
                            }
                        })
                    }
                }
            )


        })
    }

    disconnect() {
        let user_id_chat = parseInt(document.querySelector('#current_user_id').textContent);
        // window.addEventListener('beforeunload', function () {
        //     consumer.subscriptions.remove()
        //     consumer.disconnect();
        //     console.log("Canal desconectado debido al cierre de la ventana.");
        // });

        // consumer.subscriptions.remove()
        // consumer.disconnect();
    }

    refresh() {
        open_room();
    }

}